module.exports = __webpack_public_path__ + "img/article-gb-dwrg-2.b155f238.jpg";